import {
   OrganizationSubmission, ContactSubmission, QualifyCredentialsStorePayload,
} from '../models';
import { SubmissionSource, RequestStatus } from '../models/enums';
import { QualifyCredentials } from '../models/qualifyCredentials.model';

const buildCreatePayload = (payload: QualifyCredentialsStorePayload): QualifyCredentials => {
  const primaryRequestContact: ContactSubmission = {
    firstName: payload.contactFirstName,
    lastName: payload.contactLastName,
    email: payload.companyEmail,
    fax: payload.companyFax,
    organizationName: payload.companyName,
    source: SubmissionSource.QualifyCredentials,
  };

  const primaryRequestCompany: OrganizationSubmission = {
    name: payload.companyName,
    addressLine1: payload.addressLineOne,
    addressLine2: payload.addressLineTwo,
    city: payload.companyCity,
    state: payload.companyState,
    country: payload.companyCountry,
    zip: payload.companyZip,
    fax: payload.companyFax,
    email: payload.companyEmail,
    source: SubmissionSource.QualifyCredentials,
  };

  const seconaryRequestContact: ContactSubmission = {
    firstName: payload.additionalFirstName,
    lastName: payload.additionalContactLastName,
    email: payload.additionalCompanyEmail,
    fax: payload.additionalCompanyFax,
    organizationName: payload.additionalCompanyName,
    source: SubmissionSource.QualifyCredentials,
  };

  const secondaryRequestCompany: OrganizationSubmission = {
    name: payload.additionalCompanyName,
    addressLine1: payload.additionalAddressLineOne,
    addressLine2: payload.additionalAddressLineTwo,
    city: payload.additionalCompanyCity,
    state: payload.additionalCompanyState,
    country: payload.additionalCompanyCountry,
    zip: payload.additionalCompanyZip,
    fax: payload.additionalCompanyFax,
    email: payload.additionalCompanyEmail,
    source: SubmissionSource.QualifyCredentials,
  };

  const thirdRequestContact: ContactSubmission = {
    firstName: payload.thirdAdditionalFirstName,
    lastName: payload.thirdAdditionalContactLastName,
    email: payload.thirdAdditionalCompanyEmail,
    fax: payload.thirdAdditionalCompanyFax,
    organizationName: payload.thirdAdditionalCompanyName,
    source: SubmissionSource.QualifyCredentials,
  };

  const thirdRequestCompany: OrganizationSubmission = {
    name: payload.thirdAdditionalCompanyName,
    addressLine1: payload.thirdAdditionalAddressLineOne,
    addressLine2: payload.thirdAdditionalAddressLineTwo,
    city: payload.thirdAdditionalCompanyCity,
    state: payload.thirdAdditionalCompanyState,
    country: payload.thirdAdditionalCompanyCountry,
    zip: payload.thirdAdditionalCompanyZip,
    fax: payload.thirdAdditionalCompanyFax,
    email: payload.thirdAdditionalCompanyEmail,
    source: SubmissionSource.QualifyCredentials,
  };

  const generalContractorContact: ContactSubmission = {
    firstName: payload.contractorFirstName,
    lastName: payload.contractorContactLastName,
    email: payload.contractorCompanyEmail,
    source: SubmissionSource.QualifyCredentials,
  };

  return {
    primaryRequestTypeOfRecipient: payload.typeOfRecipient,
    revisedPrimaryRequestTypeOfRecipient: payload.typeOfRecipient,
    primaryRequestContact,
    revisedPrimaryRequestContact: primaryRequestContact,
    primaryRequestCompany,
    revisedPrimaryRequestCompany: primaryRequestCompany,

    secondaryRequestTypeOfRecipient: payload.additionalTypeOfRecipient,
    revisedSecondaryRequestTypeOfRecipient: payload.additionalTypeOfRecipient,
    seconaryRequestContact,
    revisedSeconaryRequestContact: seconaryRequestContact,
    secondaryRequestCompany,
    revisedSecondaryRequestCompany: secondaryRequestCompany,

    thirdRequestTypeOfRecipient: payload.thirdAdditionalTypeOfRecipient,
    revisedThirdRequestTypeOfRecipient: payload.thirdAdditionalTypeOfRecipient,
    thirdRequestContact,
    revisedThirdRequestContact: thirdRequestContact,
    thirdRequestCompany,
    revisedThirdRequestCompany: thirdRequestCompany,

    woodworkingFirm: payload.woodworkingFirm,
    revisedWoodworkingFirm: payload.woodworkingFirm,

    generalContractorContact,
    revisedGeneralContractorContact: generalContractorContact,
    status: RequestStatus.Pending,
  };
};


export default {
  buildCreatePayload,
};